import {
  AMPLITUDE_EXPERIMENT_CONTROL_NAME,
  AMPLITUDE_EXPERIMENT_VARIANT_NAME,
} from '@constants/amplitudeExperiments';

export const applyExperimentClasses = (
  variant: string,
  variantClasses: string,
  originalClasses: string,
) => (variant === '1' ? variantClasses : originalClasses);

export const isTreatment = (experimentValue: string | null): boolean =>
  experimentValue === AMPLITUDE_EXPERIMENT_VARIANT_NAME;

export const isControl = (experimentValue: string | null): boolean =>
  experimentValue === AMPLITUDE_EXPERIMENT_CONTROL_NAME;
